import { jsx as a } from "react/jsx-runtime";
import { idsLogger as s } from "../../../utils/helpers.js";
import { LoggerLevels as t } from "../../../utils/enums.js";
import { IressTab as c } from "../Tab/Tab.js";
import "../TabSet.js";
const y = (r) => (s(
  "IressTabs: mapTabs has been deprecated and will be removed in a future version of IDS, please map and render the items array directly in your application instead.",
  t.Warn
), r != null && r.length ? r.map(
  ({
    tabName: e,
    active: d,
    tabButtonText: m,
    tabButtonTestId: n,
    tabButtonOnClick: p,
    tabPanelContent: i,
    tabPanelTestId: o
  }, l) => /* @__PURE__ */ a(
    c,
    {
      value: e,
      active: d,
      "data-testid": n,
      onClick: p,
      label: m,
      children: o ? /* @__PURE__ */ a("div", { "data-testid": o, children: i }) : i
    },
    e || l
  )
) : null);
export {
  y as mapTabs
};
